export const LOGIN_PATH = '/sso';

const createRedirectURI = () => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}${LOGIN_PATH}`;
};

export default createRedirectURI;
